declare global {
    interface RouterMeta {
        title: string;
        isPublic:boolean;
    }
    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }
    interface System {
        import (request: string): Promise<any>
    }

    const System: System
}
// import login from 'views/vcponlineok/login/login.vue'
// import home from 'views/home/home.vue'

const main = () => System.import('views/main.vue');
export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => System.import('../components/lockscreen/components/locking-page.vue')
};
export const loginRouter = {
    path: '/',
    name: 'login',
    permission: '',
    meta: {
        title: 'LogIn',
        isPublic: true
    },
    component: () => System.import('views/vcponlineok/login/login.vue')
};
export const otherRouters = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: {title: 'ManageMenu'},
    component: main,
    children: [
        {
            path: 'home',
            meta: {title: 'HomePage'},
            name: 'home',
            component: () => System.import('views/home/home.vue')
        }
    ]
};


// export const ContactUs = {
//     path: '/contact-us',
//     name: 'ContactUs',
//     permission: '',
//     meta: {
//         title: 'ContactUs',
//         isPublic: true
//     },
//     component: () => System.import('views/vcponlineok/public/contact-us.vue')
// };

// export const About = {
//     path: '/about',
//     name: 'About',
//     permission: '',
//     meta: {
//         title: 'About',
//         isPublic: true
//     },
//     component: () => System.import('views/vcponlineok/public/about.vue')
// };

export const appRouters = [{
    path: '/setting',
    name: 'setting',
    permission: '',
    meta: {title: 'ManageMenu'},
    icon: '&#xe68a;',
    component: main,
    children: [
        {
            path: 'user',
            permission: 'Pages.Users',
            meta: {title: 'Users'},
            name: 'user',
            component: () => System.import('views/setting/user/user.vue')
        },
        {
            path: 'role',
            permission: 'Pages.Roles',
            meta: {title: 'Roles'},
            name: 'role',
            component: () => System.import('views/setting/role/role.vue')
        },
        {
            path: 'tenant',
            permission: 'Pages.Tenants',
            meta: {title: 'Tenants'},
            name: 'tenant',
            component: () => System.import('views/setting/tenant/tenant.vue')
        }
    ]
}];

import { staffUserRouters } from './router.staff-user';
 import { accountRouters } from './router.account';
import { errorRouters } from './router.vcponlineok';

export const routers = [
    // ContactUs,
    // About,
    loginRouter,
    locking,
    ...appRouters,
    otherRouters,
    // ...App,
    ...staffUserRouters,
     ...accountRouters,
    // ...customerUserRouters,
    ...errorRouters,
];
